<template>
	<modal
		:exibir="abrirModal"
		:titulo="tituloModal"
		@close="fecharModal"
		:custom-actions="false"
		:acao-cancelar="fecharModal"
		:acao-confirmar="salvarSelecao"
		:is-confirmar-visivel="true"
		nome-botao-confirmar="Selecionar"
		:tamanho="modalOptions"
		:max-width="modalOptions.largura"
		:permissao-confirmar="permissaoConfirmar"
		:permissao-cancelar="permissaoCancelar"
	>
		<template #body>
			<az-container>
				<v-row>
					<v-col cols="12" justify="center">
						<span class="texto-subtitulo">{{ subtitulo }}</span>
					</v-col>
					<v-col cols="12">
						<v-form lazy-validation ref="form">
							<v-autocomplete
								:items="orgaos"
								v-model="orgaoSelecionado"
								item-value="idOrgao"
								label="Órgão"
								:filter="orgaoFilter"
								:rules="orgaoRule"
							>
								<template #item="{ item }">
									<div
										v-html="
											$options.filters.HighlightBuscaFilter(item.siglaDescricao, textoBuscaOrgao)
										"
									></div>
								</template>
								<template #selection="{ item }">
									<texto-tooltip :tamanho-maximo="40" :texto="item.siglaDescricao"></texto-tooltip>
								</template>
							</v-autocomplete>
						</v-form>
					</v-col>
				</v-row>
			</az-container>
		</template>
	</modal>
</template>
<script>
import TextoTooltip from '@/views/components/TextoTooltip.vue'
import HighlightBuscaFilter from '@/views/filters/highlight-busca-filter'

export default {
	name: 'escoher-orgao-dominio',
	components: { TextoTooltip },
	filters: { HighlightBuscaFilter },
	props: {
		exibir: {
			type: Boolean,
		},
		tituloModal: {
			type: String,
			default: '',
		},
		subtitulo: {
			type: String,
			default: '',
		},
		orgaos: {
			type: Array,
			required: true,
		},
		permissaoConfirmar: {
			type: String,
			default: '',
		},
		permissaoCancelar: {
			type: String,
			default: '',
		},
	},
	emits: ['fechar', 'orgao-selecionado'],
	data() {
		return {
			orgaoSelecionado: 0,
			modalOptions: {
				largura: '500',
			},
			textoBuscaOrgao: '',
			abrirModal: false,
			orgaoRule: [(v) => !!v || 'Selecione um órgão para continuar'],
		}
	},
	watch: {
		exibir: {
			async handler(novoValor) {
				this.abrirModal = novoValor
				await this.carregarOrgaos()
				if (this.orgaos && this.orgaos.length === 1) {
					this.orgaoSelecionado = this.orgaos[0].idOrgao
				}
			},
		},
	},
	methods: {
		orgaoFilter(item, queryText) {
			const textoSiglaDescricao = item.siglaDescricao.toLowerCase()
			const searchText = queryText.toLowerCase()
			this.textoBuscaOrgao = queryText
			return textoSiglaDescricao.indexOf(searchText) > -1
		},
		async carregarOrgaos() {
			this.$emit('buscar-orgaos')
		},
		async salvarSelecao() {
			if (this.$refs.form.validate()) {
				await this.atualizarSessao(this.orgaoSelecionado)
			}
		},
		async atualizarSessao(orgaoSelecionado) {
			this.$emit('orgao-selecionado', orgaoSelecionado)
		},
		fecharModal() {
			this.$emit('fechar')
			this.limparOrgaoSelecionado()
		},
		limparOrgaoSelecionado() {
			this.orgaoSelecionado = 0
		},
	},
}
</script>
<style lang="stylus" scoped>
.texto-subtitulo
	font-size 22px
</style>
